import { CSSProperties } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Register all FA-Solid icons once so we can resolve them by string name
// (mirroring react-native-vector-icons' string-name API).
library.add(fas);

type Props = {
  name: string;
  size?: number;
  color?: string;
  solid?: boolean;
  style?: CSSProperties;
  className?: string;
};

export default function Icon({ name, size = 16, color, style, className }: Props) {
  return (
    <FontAwesomeIcon
      icon={['fas', name as any]}
      className={className}
      style={{ fontSize: size, color, width: size, height: size, ...style }}
    />
  );
}
